import { useEffect, useState } from 'react';
import { FieldValues, UseFormWatch } from 'react-hook-form';

import { Option } from 'types';

import { useAppSelector } from 'redux/hooks';
import { getUserZonesWithSpecial } from 'redux/slices/userData';

import { distributorDataService } from 'services/distributor.service';

import { useCatalogueLabels, useSeasons } from 'hooks';

import { formatSeasonLabel } from 'helpers/formatSeason';

type PriceSelect = {
  name: string;
  label: string;
  options: Option[];
};

const mapIntoOptions = (data?: string[], toLabel: (item: string) => string = (item) => item) =>
  data && data.length > 0
    ? data?.map((item: string) => ({
        value: item,
        label: toLabel(item),
      }))
    : [];

const useInputsData = (watch: UseFormWatch<FieldValues>): PriceSelect[] => {
  const zones = useAppSelector(getUserZonesWithSpecial);
  const seasons = useAppSelector((state) => state.userData.user.season);

  const { categoryLabel } = useCatalogueLabels();
  const [genders, gendersSet] = useState<string[]>([]);
  const [lines, linesSet] = useState<string[]>([]);

  const { season, marketLine, zone, genderCode } = watch();

  const { currentSeasonLines, linesList } = useSeasons(seasons, season);

  const seasonItems = linesList.map((item) => ({
    value: item.season,
    label: formatSeasonLabel(item.season),
  }));

  const zonesItems = zones?.map((item) => ({
    value: item.code,
    label: item.code,
  }));

  useEffect(() => {
    if (season && marketLine) {
      distributorDataService.getGender(season, marketLine).then((res) => {
        gendersSet(res.data);
      });
    }
  }, [season, marketLine]);

  useEffect(() => {
    if (season && marketLine && genderCode) {
      distributorDataService.getLine(season, marketLine, genderCode).then((res) => {
        linesSet(res.data);
      });
    }
  }, [season, marketLine, genderCode]);

  return [
    {
      name: 'season',
      label: 'season',
      options: seasonItems,
    },
    {
      name: 'marketLine',
      label: 'catalogue',
      options: mapIntoOptions(currentSeasonLines?.catalog),
    },
    {
      name: 'zone',
      label: 'zone',
      options: marketLine ? zonesItems : [],
    },
    {
      name: 'genderCode',
      label: 'gender',
      options: zone ? mapIntoOptions(genders) : [],
    },
    {
      name: 'category',
      label: 'line',
      options: genderCode ? mapIntoOptions(lines, categoryLabel) : [],
    },
  ];
};

export { useInputsData };
